import React, { Component } from "react";
import { Config } from "constant";
import styled, { css } from "styled-components";
import { graphql } from "react-apollo";
import Moment from "moment";
import { queryGetChannels } from "Apollo";
import { ShowNotice } from "Store";
import NotificationBox from "module-common/NotificationBox";
import Button from "module-common/Button";
import Icon from "module-common/Icon";
import ChannelCard from "./ChannelCard";
import backgroundSetup from "../../img/nolimit/background-setup.png";
import logoCare from "../../img/nolimit/logo-shadow.png";

export default graphql(queryGetChannels)(
  class ConnectAccount extends Component {
    state = {
      renders: [],
      channelName: []
    };

    componentWillReceiveProps(nextProps) {
      const { getCompanyChannelHandler } = nextProps.data;
      const { renders, channelName } = this.state;
      if (getCompanyChannelHandler) {
        for (const channel of getCompanyChannelHandler) {
          renders.push(
            <ChannelCard
              key={channel.id}
              id={channel.id}
              name={channel.name}
              displayName={channel.displayName}
              displayPicture={channel.displayPicture}
              dateCreated={Moment(channel.dateCreated)}
              channel={channel.channel.name}
            />
          );
          channelName.push(channel.channel.name);
        }
      }
    }
    render() {
      const { renders, channelName } = this.state;

      return (
        <Screen>
          <LogoCare alt="logo care" src={logoCare} />
          <Panel onSubmit={event => event.preventDefault()}>
            <Strong>Connect Account</Strong>
            <Count>Step 2/2</Count>
            <Buttons>
              <ChannelButtonWrapper>
                <IconConnectFB
                  key="fan-page"
                  name="facebook-full"
                  onClick={
                    channelName.find(e => e == "facebook") === "facebook"
                      ? null
                      : () => this.onClick("facebook")
                  }
                  isDisabled={
                    channelName.find(e => e == "facebook") === "facebook"
                      ? true
                      : false
                  }
                />
                <ChannelText>Fan Page</ChannelText>
              </ChannelButtonWrapper>
              <ChannelButtonWrapper>
                <IconConnectTwitter
                  key="account"
                  name="twitter-full"
                  onClick={
                    channelName.find(e => e == "twitter") === "twitter"
                      ? null
                      : () => this.onClick("twitter")
                  }
                  isDisabled={
                    channelName.find(e => e == "twitter") === "twitter"
                      ? true
                      : false
                  }
                />
                <ChannelText>Account</ChannelText>
              </ChannelButtonWrapper>
              <ChannelButtonWrapper>
                <IconConnectIG
                  key="business-account"
                  name="instagram-full"
                  onClick={
                    channelName.find(e => e == "instagram") === "instagram"
                      ? null
                      : () => this.onClick("instagram")
                  }
                  isDisabled={
                    channelName.find(e => e == "instagram") === "instagram"
                      ? true
                      : false
                  }
                />
                <ChannelText>Business Account</ChannelText>
              </ChannelButtonWrapper>
            </Buttons>
            {channelName.length === 0 ? (
              <Notabene>
                NB: You required to connect at least one account, <br /> and you
                can connect max one account for each Social Media Channel
              </Notabene>
            ) : null}
            <ChannelWrapper>{renders}</ChannelWrapper>
            <SecButton>
              <Register type="Submit" onClick={this.onFinish}>
                Finish
              </Register>
            </SecButton>
          </Panel>
        </Screen>
      );
    }
    onFinish = () => {
      const { channelName } = this.state;
      if (channelName.length === 0) {
        ShowNotice("connect-account-error");
      } else {
        window.location = "/case-management";
      }
    };
    onClick = channel => {
      const onClick = this.props.onClick;
      if (onClick) onClick(channel);

      const origin = window.location.origin;

      let link;
      switch (channel) {
        case "facebook":
          link = `${
            Config.apiUrl
          }/authorize/social_media/facebook?redirect_uri=${origin}/connect-account`;
          window.open(link, "_self");
          break;
        case "twitter":
          link = `${
            Config.apiUrl
          }/authorize/social_media/twitter?redirect_uri=${origin}/connect-account`;
          window.open(link, "_self");
          break;
        case "instagram":
          link = `${
            Config.apiUrl
          }/authorize/social_media/instagram?redirect_uri=${origin}/connect-account`;
          window.open(link, "_self");
          break;
        default:
          break;
      }
    };
  }
);

const Screen = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${backgroundSetup});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
`;

const LogoCare = styled.img`
  display: flex;
  width: 275px;
  height: auto;
  justify-content: center;
  margin-bottom: 10px;
`;

const Strong = styled.span`
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
  color: #3bbeb6;
`;

const Notabene = styled.div`
  margin-top: 30px;
  text-align: center;
`;

const Count = styled.div`
  position: fixed;
  top: 30px;
  right: 30px;
  font-size: 16px;
  color: #898989;
`;
const Panel = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: none;
  width: 800px;
  height: 450px;
  padding: 30px 50px;
  margin-bottom: 50px;
  margin-left: 0px;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.1);
`;

const IconConnectFB = styled(Icon)`
  width: 95px;
  height: 95px;
  border: 8px solid #e7e9f6;
  border-radius: 50%;
  justify-content: center;

  &:hover {
    opacity: 1;
  }
  ${props =>
    props.isDisabled
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0.5;
        `};
`;

const IconConnectTwitter = styled(Icon)`
  width: 95px;
  height: 95px;
  border: 8px solid #e7e9f6;
  border-radius: 50%;
  justify-content: center;
  &:hover {
    opacity: 1;
  }
  ${props =>
    props.isDisabled
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0.5;
        `};
`;

const IconConnectIG = styled(Icon)`
  width: 95px;
  height: 95px;
  border: 8px solid #e7e9f6;
  border-radius: 50%;
  justify-content: center;
  &:hover {
    opacity: 1;
  }
  ${props =>
    props.isDisabled
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0.5;
        `};
`;

const ChannelButtonWrapper = styled.div`
  justify-content: center;
  padding: 10px;
  margin-left: 50px;
  margin-right: 50px;
  justify-content: center;
`;
const ChannelText = styled.div`
  margin-top: 5px;
  font-size: 13px;
  color: #898989;
  text-align: center;
  justify-content: center;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

const ChannelWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 50px;
`;

const Register = styled.button`
  flex: 1;
  display: flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: white;
  transition: 0.3s;
  font-size: 14px;
  cursor: pointer;
  border-radius: 30px;
  white-space: nowrap;
  user-select: none;
  padding: 10px;
  background: #01adef;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 2px 0px;
`;
const SecButton = styled.section`
  display: flex;
  flex: none;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
`;



// WEBPACK FOOTER //
// ./src/module-first-time/connect-account/ConnectAccount.js